import { Nullable } from 'interfaces/Nullable.ts';
import { QueryState } from '@/common/enum';
import { IUserPortal } from 'interfaces/UserAccountInfo.interface.ts';
import SitePermissionTypes from '@/common/enum/SitePermissionTypes.ts';

export type AuthTokenTypes = {
  queryState: QueryState;
  token: Nullable<string>;
  tokenVerification: Nullable<IUserPortal>;
  userId: Nullable<number>;
  accessType: Nullable<SitePermissionTypes>;
  error: Nullable<string>;
  username: Nullable<string>;
  /**
   * Expiry of the Cognito ID token that carried this session, in epoch SECONDS.
   * The Palmetto access token itself is opaque, so the ID token's `exp` is the
   * only client-visible signal that the session is about to die. Null means
   * unknown, which is treated as still-valid.
   */
  tokenExpiresAt: Nullable<number>;
  /**
   * Raw Cognito ID token (JWT) that carried this session. `token` above is the
   * opaque Palmetto access token unpacked from this JWT's `custom:chunk` claims;
   * the DMA API's Cognito authorizer accepts only the JWT itself. Null means the
   * session predates this field or has ended.
   *
   * This is a bearer credential -- it belongs in requests, never in a log line
   * or an error message.
   */
  jwtToken: Nullable<string>;
};

export const AuthTokenInitialState: AuthTokenTypes = {
  queryState: QueryState.UNDEFINED,
  token: null,
  tokenVerification: null,
  userId: null,
  accessType: null,
  error: null,
  username: null,
  tokenExpiresAt: null,
  jwtToken: null,
};
